import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// NOTE: localStorage token storage is acceptable for this use case (event platform, not banking).
// For production with sensitive data: migrate to httpOnly cookies + CSRF protection.
const api = axios.create({ baseURL: `${API_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rsx_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('rsx_token');
      localStorage.removeItem('rsx_user');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
